import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Navbar from '../components/Navbar';
import '../styles/statistics.css'

function Player_Statistics() {
  const [playerList, setPlayerList] = useState([]);
  const [selectedPlayer, setSelectedPlayer] = useState('');
  const [playerGamesData, setPlayerGamesData] = useState([]);
  const [playerBuyinData, setPlayerBuyinData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem('token');

  useEffect(() => {
    setIsLoading(true)
    axios.get(`https://kaskas.pro/poker-stats-server/api/api/getAllPlayers`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      const data = response.data
      if (!data.allPlayersNames) {
        return;
      }
      setPlayerList(data.allPlayersNames);
      setIsLoading(false)
    }).catch(err => {
      console.log(err);
      setIsLoading(false)
    })
  }, [])

  const handleNameChange = (event) => {
    setIsLoading(true)
    const playerName = event.target.value;
    setSelectedPlayer(playerName);
    axios.post(`https://kaskas.pro/poker-stats-server/api/api/getPlayerStatistics`, { playerName }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      const data = response.data
      if (!data.playerStats) return;
      setPlayerBuyinData(data.playerStats.buyinData);
      setPlayerGamesData(data.playerStats.allPlayerGamesData);
      setIsLoading(false)
      console.log(data.playerStats)
    }).catch(err => {
      console.log(err);
      setIsLoading(false)
    })
  }

  const getMaxBuyin = (buyinArray) => {
    let maxBuyin = 0;
    buyinArray.forEach(buyin => {
      maxBuyin = Math.max(buyin.buyin_amount, maxBuyin);
    })
    return maxBuyin
  }

  const getTotalBuyins = (buyinArray) => {
    let sum = 0;
    buyinArray.forEach(buyin => {
      sum += buyin.buyin_amount;
    })
    return sum;
  }

  const getMaxWin = (gamesArray) => {
    let maxWin = 0;
    gamesArray.forEach(gameData => {
      maxWin = Math.max(gameData.player_profit, maxWin)
    })
    return maxWin;
  }

  const getMostLost = (gamesArray) => {
    let mostLost = 0;
    gamesArray.forEach(gameData => {
      mostLost = Math.min(gameData.player_profit, mostLost)
    })
    return mostLost;
  }

  const getTotalProfit = (gamesArray) => {
    let sum = 0;
    gamesArray.forEach(gameData => {
      sum += gameData.player_profit;
    })
    return sum;
  }

  const getTotalRake = (gamesArray) => {
    let sum = 0;
    gamesArray.forEach(gameData => {
      sum += gameData.player_rake;
    })
    return sum;
  }

  const getAverageProfitPerGame = (gamesArray) => {
    if (gamesArray.length === 0) return 0;
    return Math.floor(getTotalProfit(gamesArray) / gamesArray.length);
  }

  return (
    <>
      {isLoading ? <div className='loaderWrapper'><div className='loader'></div></div> :
        <>
          <Navbar selectedItem={'playerStatistics'} />

          <div className='selectWrapper'>
            <select className='statisticsSelect' onChange={handleNameChange} value={selectedPlayer}>
              <option value="" disabled>בחירת שחקן</option>
              {playerList.map((player, index) => (
                <option key={index} value={player.player_name}>{player.player_name}</option>
              ))}
            </select>
          </div>
          <div className='tableWrapper'>
            <table className="statisticsTable">
              <thead>
                <tr>
                  <th>כמות</th>
                  <th>קטגוריה</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{getMaxWin(playerGamesData)}</td>
                  <td>משחק הכי רווחי</td>
                </tr>
                <tr>
                  <td>{getAverageProfitPerGame(playerGamesData)}</td>
                  <td>ממוצע רווח למשחק</td>
                </tr>
                <tr>
                  <td>{getTotalProfit(playerGamesData)}</td>
                  <td>סך הכל רווח/הפסד</td>
                </tr>

                <tr>
                  <td>{getMostLost(playerGamesData)}</td>
                  <td>משחק הכי רווחי לאחרים</td>
                </tr>

                <tr>
                  <td>{getMaxBuyin(playerBuyinData)}</td>
                  <td>פריטה הכי גבוהה</td>
                </tr>
                <tr>
                  <td>{getTotalBuyins(playerBuyinData)}</td>
                  <td>סכום כל הפריטות</td>
                </tr>
                <tr>
                  <td>{getTotalRake(playerGamesData)}</td>
                  <td>סכום כל הגניות</td>
                </tr>

                <tr>
                  <td>{playerGamesData.length}</td>
                  <td>סך הכל משחקים</td>
                </tr>
              </tbody>
            </table>
          </div>

        </>}
    </>
  )
}

export default Player_Statistics